// frontend/src/components/CRSFormSections/WorkExperienceSection.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import {
  BAD_VALUE,
  canadianWorkExperienceOptions,
  foreignWorkExperienceOptions
} from '../../constants/crsFormOptions'; // Adjust path as needed

function WorkExperienceSection({ formData, handleChange, handleFocus }) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="h6" sx={{ mt: 2 }}>Work Experience</Typography>

      {/* Canadian Work Experience */}
      <FormControl fullWidth required>
        <InputLabel id="canadian-work-experience-label">6a. In the last ten years, how many years of skilled work experience in Canada do you have?</InputLabel>
        <Select
          labelId="canadian-work-experience-label"
          name="canadianWorkExperience"
          value={formData.canadianWorkExperience}
          label="6a. In the last ten years, how many years of skilled work experience in Canada do you have?"
          onChange={handleChange}
          onFocus={() => handleFocus('canadianWorkExperience')}
        >
          {canadianWorkExperienceOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Foreign Work Experience */}
      <FormControl fullWidth required>
        <InputLabel id="foreign-work-experience-label">6b. In the last 10 years, how many total years of foreign skilled work experience do you have?</InputLabel>
        <Select
          labelId="foreign-work-experience-label"
          name="foreignWorkExperience"
          value={formData.foreignWorkExperience}
          label="6b. In the last 10 years, how many total years of foreign skilled work experience do you have?"
          onChange={handleChange}
          onFocus={() => handleFocus('foreignWorkExperience')}
        >
          {foreignWorkExperienceOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default WorkExperienceSection;